import type { Template } from "@/types";

export const LA_05_H2_V3: Template[] = [
    {
        id: "la-05-h2v3-01",
        name: "LA 01 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 139, y: 43, width: 196, height: 267, rotation: 0, imageRotation: 0 },
            { id: "2", x: 139, y: 317, width: 196, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 43, width: 195, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 317, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 841, y: 0, width: 346, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-02",
        name: "LA 02 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 165, y: 0, width: 346, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 42, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 173, width: 195, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1017, y: 42, width: 196, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 173, width: 196, height: 267, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-03",
        name: "LA 03 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 165, y: 0, width: 346, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 42, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 173, width: 195, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1017, y: 42, width: 196, height: 267, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 316, width: 196, height: 124, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-04",
        name: "LA 04 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 202, y: 46, width: 273, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 812, y: 46, width: 405, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 812, y: 312, width: 96, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 915, y: 312, width: 200, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1123, y: 312, width: 94, height: 125, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-05",
        name: "LA 05 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 157, y: 46, width: 364, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 405, y: 275, width: 115, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 157, y: 275, width: 241, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 71, width: 237, height: 341, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 71, width: 237, height: 341, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-06",
        name: "LA 06 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 60, y: 62, width: 555, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 841, y: 62, width: 346, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 841, y: 277, width: 110, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 277, width: 110, height: 145, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1077, y: 277, width: 110, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-07",
        name: "LA 07 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 80, width: 224, height: 323, rotation: 0, imageRotation: 0 },
            { id: "2", x: 232, y: 80, width: 496, height: 323, rotation: 0, imageRotation: 0 },
            { id: "3", x: 735, y: 80, width: 114, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 735, y: 245, width: 114, height: 158, rotation: 0, imageRotation: 0 },
            { id: "5", x: 857, y: 80, width: 495, height: 323, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-08",
        name: "LA 08 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 193, width: 185, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 192, y: 193, width: 383, height: 259, rotation: 0, imageRotation: 0 },
            { id: "2", x: 583, y: 193, width: 185, height: 259, rotation: 0, imageRotation: 0 },
            { id: "5", x: 775, y: 193, width: 383, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1165, y: 193, width: 187, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-09",
        name: "LA 09 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 93, y: 42, width: 279, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 380, y: 42, width: 278, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 666, y: 42, width: 278, height: 400, rotation: 0, imageRotation: 0 },
            { id: "4", x: 951, y: 42, width: 306, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 951, y: 246, width: 306, height: 196, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-10",
        name: "LA 10 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h2_v3_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 80, width: 224, height: 323, rotation: 0, imageRotation: 0 },
            { id: "2", x: 232, y: 80, width: 496, height: 323, rotation: 0, imageRotation: 0 },
            { id: "3", x: 735, y: 80, width: 495, height: 323, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1238, y: 80, width: 114, height: 158, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1238, y: 245, width: 114, height: 158, rotation: 0, imageRotation: 0 }
        ],
    }
];